// frontend/src/components/layouts/RootLayout.tsx

import { Outlet } from 'react-router-dom';
import { GlobalLoadingIndicator } from '@/components/shared/GlobalLoadingIndicator';
import { ThemeProvider } from '@/components/shared/ThemeProvider';
import { Toaster } from '@/components/ui/sonner';

export default function RootLayout() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <GlobalLoadingIndicator />
      <Outlet />
      <Toaster position="bottom-right" />
    </ThemeProvider>
  );
}
